import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  Box,
  SubHeadingStyled,
  DataContainerHeader,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { SettingsWrapper, FormDataContainer } from "./styled";
import { useNavigate } from "react-router-dom";
import {
  PlaceholderImg,
  SearchIcon,
} from "../../../components/styled/AllImages";
import ListTable from "../../../components/common/tables/ListTable";
import { adminsListColumns } from "../../../helpers/adminConstants/TableConstants";
import FloatingInput from "../../../components/common/inputFields/FloatingInput";
import AdminsListApi from "../../../services/api/adminListApi";
import { useDebounce } from "../../../hooks/useDebounce";

const AdminsList = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const [adminsListRows, setAdminsListRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleView = (user) => {
    navigate(`/settings/admins-list/view-admin/${user.id}`);
  };
  const [activePage, setActivePage] = useState(1);
  const [totalCount, setTotalCount] = useState(null);
  const [perPage, setPerPage] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;

  const getAdminsList = async (page = 1, query = "") => {
    try {
      setLoading(true);
      const response = await AdminsListApi.adminsList(page, query);
      if (response?.data) {
        // Transform temporary_admins for the table
        const adminsListResponse = response?.data?.data || []; // Fallback to an empty array
        const adminsListView = adminsListResponse.map((item) => ({
          id: item.id,
          type: item.user_detail.office_location.location_type == 1 ? t("headquarter") : t("branch"),
          department: {
            name:
              language === "ar"
                ? item?.user_detail?.department?.name_ar
                : item?.user_detail?.department?.name_en,
            branch:
              language === "ar"
                ? item?.user_detail?.office_location?.name_ar
                : item?.user_detail?.office_location?.name_en,
          },
          user: {
            name: item?.name,
            image: item?.profile
              ? `${ASSET_URL}/${item?.profile}`
              : PlaceholderImg,
            userRole: item?.position,
            userName: item?.name,
            user_info: [
              {
                title: "JobRoll",
                value: item?.position,
              },
              {
                title: "ContactEmail",
                value: item?.user_detail?.office_location?.email,
              },
              {
                title: "no_of_users",
                value: item?.user_detail?.licenses_created,
              },
            ],
          },
          no_of_licenses: item?.user_detail?.licenses_allowed,
          no_of_users: item?.user_detail?.licenses_created,
          no_of_licenses_left: item?.user_detail?.licenses_left,
        }));
        setAdminsListRows(adminsListView);
        setTotalCount(response?.data?.total);
        setPerPage(response?.data?.per_page);
      } else {
        setAdminsListRows([]);
        setTotalCount(null);
        setPerPage(null);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };


  const handleSearch = (e) => {
    const query = e.target.value.trim();
    setSearchQuery(query);
  };

  // useEffect(() => {
  //     getData();
  // }, [language, activePage]);

  useEffect(() => {
    getAdminsList(activePage, debouncedSearchQuery);
  }, [activePage, debouncedSearchQuery, language]);

  return (
    <SettingsWrapper>
      <Box className="content-head">
        <SubHeadingStyled size="16px" color="var(--text)">
          {t("settings")}
        </SubHeadingStyled>
        <Box>
          <FloatingInput
            name="search"
            type="input"
            fieldType="text"
            placeholder={t("search_by_name")}
            icon={SearchIcon}
            onChange={handleSearch}
          />
        </Box>
      </Box>
      {loading ? (
        <ThemeLoader />
      ) : (
        <>
          <Box className="content-container">
            <Row className="mt-3">
              <Col md={12}>
                <FormDataContainer className="dataContainer">
                  <DataContainerHeader label={t("admins_list")} />
                </FormDataContainer>
              </Col>
            </Row>
          </Box>
          <Box>
            <ListTable
              options={["view"]}
              rows={adminsListRows}
              columns={adminsListColumns}
              onViewDetails={handleView}
              totalCount={totalCount}
              perPage={perPage}
              activePage={activePage}
              setActivePage={setActivePage}
            />
          </Box>
        </>
      )}
    </SettingsWrapper>
  );
};

export default AdminsList;
